import React from 'react';
import styled from 'styled-components';

interface Tab {
  id: string;
  label: string;
}

interface FilterTabsProps {
  tabs: Tab[];
  activeTab: string;
  onTabChange: (tabId: string) => void;
}

const TabsContainer = styled.div`
  display: flex;
  gap: 12px;
  margin-bottom: 20px;
  width: 100%;
  overflow-x: auto;
  padding: 4px 0;
  
  /* Hide scrollbar but allow scrolling */
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera */
  }
`;

const TabButton = styled.button<{ $active: boolean }>`
  background-color: ${({ $active }) => $active ? '#9333EA' : 'rgba(255, 255, 255, 0.05)'};
  color: ${({ $active }) => $active ? '#fff' : 'rgba(255, 255, 255, 0.7)'};
  border: none;
  border-radius: 20px;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: ${({ $active }) => $active ? '600' : '400'};
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  flex-shrink: 0;
  
  &:hover {
    background-color: ${({ $active }) => $active ? '#A855F7' : 'rgba(255, 255, 255, 0.1)'};
  }
  
  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    padding: 6px 14px;
    font-size: 13px;
  }
`;

const FilterTabs: React.FC<FilterTabsProps> = ({ tabs, activeTab, onTabChange }) => {
  return (
    <TabsContainer>
      {tabs.map((tab) => (
        <TabButton
          key={tab.id}
          $active={activeTab === tab.id}
          onClick={() => onTabChange(tab.id)}
        >
          {tab.label}
        </TabButton>
      ))}
    </TabsContainer>
  );
};

export default FilterTabs;
